import {
  ReportBuilderDataSourceId,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import { FactTables } from '../../models/fact-tables';
import { ReportBuilderColumns } from '../../report-builder-columns';
import { ReportBuilderDataSourceInstance } from '../report-builder-data-source-instance';
import { ReportBuilderGroups } from '../report-builder-groups';
import { ReportBuilderScopeDataAccessors } from '../report-builder-scope-data-accessors';

export class LabJobsDataSource extends ReportBuilderDataSourceInstance {
  override readonly id = ReportBuilderDataSourceId.LabJobs;
  override readonly name = 'Lab Jobs';
  override readonly description =
    'One result per lab job within Principle. This includes information about the lab, patient, appointment and practitioner associated with each lab job.';
  override readonly factTable = FactTables.labJobEvent.latestEvent;
  override readonly rowItemName = 'Lab Job';

  override readonly queryableTimestamps = [
    { property: this.factTable.labJob.createdAt },
    { property: this.factTable.labJob.dueDate },
    { property: this.factTable.appointment.date },
    { property: this.factTable.timestamp },
  ];

  scopes = [TemplateScope.Appointment, TemplateScope.Patient];
  scopeDataAccessor = ReportBuilderScopeDataAccessors.build([
    this.factTable.appointment,
    this.factTable.patient,
  ]);

  override readonly groupByOptions = [
    ReportBuilderGroups.toGroup('Common', [
      ReportBuilderGroups.toOption(this.factTable.practitioner.name),
      ReportBuilderGroups.toOption(this.factTable.labJob.type),
      ReportBuilderGroups.toOption(this.factTable.labJob.status),
      ReportBuilderGroups.toOption(this.factTable.lab.name),
    ]),
  ];

  override readonly availableColumns = [
    ReportBuilderColumns.toColumnGroup('Lab Job', [
      this.factTable.practitioner.name,
      this.factTable.lab.name,
      this.factTable.labJob.type,
      this.factTable.labJob.status,
      this.factTable.labJob.cost,
      this.factTable.labJob.dueDate,
      this.factTable.appointment.date,
      this.factTable.patient.name,
      this.factTable.labJob.createdAt,
      this.factTable.labJob.hasPractitioner,
    ]),
  ];

  override readonly defaultColumns = ReportBuilderColumns.toReferences([
    this.factTable.practitioner.name,
    this.factTable.lab.name,
    this.factTable.labJob.type,
    this.factTable.labJob.status,
    this.factTable.labJob.cost,
    this.factTable.labJob.dueDate,
    this.factTable.appointment.date,
    this.factTable.patient.name,
    this.factTable.labJob.createdAt,
    this.factTable.labJob.hasPractitioner,
  ]);
}
